export class UrlProvider {
    static get root() {

        // return `${location.protocol}//r2.eurowheels.dk/fleet`;

        const otherUrl = document?.querySelector("map-viewer");
        if (otherUrl && otherUrl.hasAttribute("server-url"))
            return otherUrl.getAttribute("server-url");

        if (window.location.host.toLowerCase().endsWith("eurowheels.dk"))
            return `${location.protocol}//${location.host}${location.pathname}`;
        
        return  window.location.origin;
    }

    static get fleetRoot() {
        if (window.location.host.toLowerCase().endsWith("eurowheels.dk") || window.location.host.toLowerCase().endsWith("eurowheels-local.dk"))
            return `${location.protocol}//r2.eurowheels.dk/fleet`;
        
        return  window.location.origin;
    }
}